{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "question_items",
  "$defs": {
    "image": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["image"]
        },
        "content": {
          "type": "object",
          "properties": {
            "original_url": {
              "type": ["string", "null"]
            },
            "url": {
              "type": ["string", "null"]
            },
            "code": {
              "type": ["string", "null"]
            },
            "generation_completed": {
              "type": ["boolean"]
            }
          },
          "required": ["original_url", "url", "code", "generation_completed"],
          "additionalProperties": false
        },
        "fill_in_the_blanks": {
          "type": "boolean"
        },
        "description": {
          "type": ["string", "null"]
        },
        "title": {
          "type": ["string", "null"]
        },
        "not_to_scale": {
          "type": "boolean"
        },
        "style": {
          "type": ["object", "null"],
          "patternProperties": {
            ".*": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "container_width": {
          "type": ["string", "null"]
        }
      },
      "required": ["type", "content"],
      "additionalProperties": false
    },
    "text": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["text"]
        },
        "content": {
          "type": "string"
        },
        "fill_in_the_blanks": {
          "type": "boolean"
        }
      },
      "required": ["type", "content"],
      "additionalProperties": false
    },
    "table": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["table"]
        },
        "content": {
          "type": "string"
        },
        "fill_in_the_blanks": {
          "type": ["boolean", "null"]
        },
        "description": {
          "type": ["string", "null"]
        },
        "title": {
          "type": ["string", "null"]
        },
        "style": {
          "type": ["object", "null"],
          "patternProperties": {
            ".*": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "container_width": {
          "type": ["string", "null"]
        }
      },
      "required": ["type", "content"],
      "additionalProperties": false
    },
    "content_item": {
      "oneOf": [
        {
          "$ref": "#/$defs/text"
        },
        {
          "$ref": "#/$defs/image"
        },
        {
          "$ref": "#/$defs/table"
        }
      ]
    },
    "stem": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["stem"]
        },
        "content_items": {
          "type": "array",
          "items": {
            "$ref": "#/$defs/content_item"
          }
        },
        "markscheme": {
          "type": ["object", "null"],
          "properties": {
            "all_mark_groups": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "id": {
                    "type": "string"
                  },
                  "topic_ids": {
                    "type": "array",
                    "items": {
                      "type": "number"
                    }
                  },
                  "mark_code": {
                    "type": ["string", "null"]
                  },
                  "marks": {
                    "type": "number"
                  },
                  "notes": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "criterion": {
                    "type": "array",
                    "items": {
                      "$ref": "#/$defs/content_item"
                    }
                  }
                },
                "required": [
                  "id",
                  "topic_ids",
                  "mark_code",
                  "marks",
                  "notes",
                  "criterion"
                ],
                "additionalProperties": false
              }
            },
            "solution_paths": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "mark_group_refs": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "worked_solution": {
                    "type": "array",
                    "items": {
                      "$ref": "#/$defs/content_item"
                    }
                  }
                },
                "required": ["mark_group_refs", "worked_solution"],
                "additionalProperties": false
              }
            }
          },
          "required": ["all_mark_groups", "solution_paths"],
          "additionalProperties": false
        }
      },
      "required": ["type", "content_items", "markscheme"],
      "additionalProperties": false
    }
  },
  "type": "array",
  "items": {
    "oneOf": [
      {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "enum": ["stimulus"]
          },
          "content_items": {
            "type": "array",
            "items": {
              "$ref": "#/$defs/content_item"
            }
          }
        },
        "required": ["type", "content_items"],
        "additionalProperties": false
      },
      {
        "$ref": "#/$defs/stem"
      },
      {
        "$ref": "#/$defs/image"
      },
      {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "enum": ["stem_group"]
          },
          "content_items": {
            "type": "array",
            "items": {
              "$ref": "#/$defs/content_item"
            }
          },
          "stems": {
            "type": "array",
            "items": {
              "$ref": "#/$defs/stem"
            }
          }
        },
        "required": ["type", "content_items", "stems"],
        "additionalProperties": false
      },
      {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "enum": ["options"]
          },
          "content_items": {
            "type": "array",
            "items": {
              "$ref": "#/$defs/content_item"
            }
          },
          "layout": {
            "type": "string",
            "enum": ["one-column", "two-column"]
          },
          "options": {
            "type": "array",
            "items": {
              "type": "object",
              "properties": {
                "content_items": {
                  "type": "array",
                  "items": {
                    "$ref": "#/$defs/content_item"
                  }
                }
              },
              "additionalProperties": false
            }
          },
          "markscheme": {
            "type": "object",
            "properties": {
              "marks": {
                "type": "number"
              },
              "correct_option_indexes": {
                "type": "array",
                "items": {
                  "type": "number"
                }
              },
              "max_selection_count": {
                "type": "number"
              },
              "min_selection_count": {
                "type": "number"
              },
              "topic_ids": {
                "type": "array",
                "items": {
                  "type": "number"
                }
              },
              "worked_solution": {
                "type": "array",
                "items": {
                  "$ref": "#/$defs/content_item"
                }
              }
            },
            "required": ["marks", "correct_option_indexes", "topic_ids"],
            "additionalProperties": false
          }
        },
        "required": ["type", "content_items", "options", "markscheme"],
        "additionalProperties": false
      }
    ]
  }
}
